import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LogOutAction } from '@shared/store/actions/auth.actions';
import { AppStates } from '@shared/store/state/app.state';
import { BehaviorSubject, Subject } from 'rxjs';

import { MenuChangeEvent } from './api/menuchangeevent';
@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuSource = new Subject<MenuChangeEvent>();
  private resetSource = new Subject();
  private expandSubmenu = new BehaviorSubject<boolean>(null);

  menuSource$ = this.menuSource.asObservable();
  resetSource$ = this.resetSource.asObservable();
  expandSubmenu$ = this.expandSubmenu.asObservable();

  constructor(private readonly store: Store<AppStates>) {}

  onMenuStateChange(event: MenuChangeEvent) {
    this.menuSource.next(event);
  }

  reset() {
    this.resetSource.next(true);
  }

  onLogout() {
    this.store.dispatch(new LogOutAction());
  }

  onExpandSubmenu() {
    this.expandSubmenu.next(!this.expandSubmenu.value);
  }
}
